export default __webpack_public_path__ + "static/media/reaper-intro.8b3a3651.mp3";